import React from 'react';
import { ListItem } from './styles';

export interface Props {
  children: React.ReactNode;
}

export default function List({ children }: Props): JSX.Element {
  return <ListItem>{children}</ListItem>;
}
